import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { PlayerSelectionSearchResult } from './PlayerSelectionSearchResult';
import { playersSelector } from '../../../../../../../store/js/modules/statspro/player-comparison/selectors';
import { usePlayerProfile } from '../../../../common/hooks/use-player-profile';

import { Loader } from '../../../../../../../../../common/react/components/Loader';
import { getTranslation } from '../../../../../../../../../common/react/utils/translations';

const RESULTS_TO_SHOW = 20;

export const PlayerSelectionSearchResults = ({
    isLoading,
    results,
    query,
    seasonId
}) => {
    const currentPlayers = useSelector(playersSelector);
    const [currentPlayersLength, setCurrentPlayersLength] = useState();

    const playerProfile1 = usePlayerProfile(
        seasonId,
        Object.values(currentPlayers)[0]
    );
    const playerProfile2 = usePlayerProfile(
        seasonId,
        Object.values(currentPlayers)[1]
    );

    useEffect(() => {
        if (
            Object.values(currentPlayers)[0] &&
            Object.values(currentPlayers)[1]
        ) {
            setCurrentPlayersLength(2);
        } else if (
            !Object.values(currentPlayers)[0] &&
            !Object.values(currentPlayers)[1]
        ) {
            setCurrentPlayersLength(0);
        } else {
            setCurrentPlayersLength(1);
        }
    }, [currentPlayers]);

    return (
        <div className="player-selection__results">
            <div className="player-selection__results-info">
                <span>
                    {getTranslation(
                        'label.statspro.playerComparison.addMultiplePlayers'
                    )}
                </span>
                <span>
                    {currentPlayersLength}{' '}
                    {getTranslation('label.of').toLowerCase()} 2
                </span>
            </div>

            <ul className="player-selection__current-players">
                {playerProfile1 && (
                    <PlayerSelectionSearchResult
                        result={playerProfile1}
                        isFixed={true}
                    />
                )}
                {playerProfile2 && (
                    <PlayerSelectionSearchResult
                        result={playerProfile2}
                        isFixed={true}
                    />
                )}
            </ul>

            <ul
                className={
                    'stats-search__results is-visible' +
                    (!results?.length ? ' has-no-results' : '')
                }
            >
                {isLoading ? (
                    <Loader />
                ) : results && results.length ? (
                    results.slice(0, RESULTS_TO_SHOW).map((result, i) => {
                        return (
                            <PlayerSelectionSearchResult
                                key={i}
                                result={result}
                                query={query}
                            />
                        );
                    })
                ) : (
                    getTranslation('label.search.noResultsFound')
                )}
            </ul>
        </div>
    );
};

PlayerSelectionSearchResults.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    results: PropTypes.array,
    query: PropTypes.string,
    seasonId: PropTypes.string
};
